module.exports = __webpack_public_path__ + "img/logo2_negro.534358c2.png";